// The tutorial's saved state for the login in this browser (src/lib/tutorialCore.js createTutorialStore). No store at all in a test
// run: nothing is read or written, and no tour or card appears.
import { supabase } from './supabase'
import { createTutorialStore, isAutomated } from './tutorialCore'

let store = null, storeUid = null
export const tutorialAutomated = () => (typeof window === 'undefined' ? true : isAutomated({ nav: window.navigator, search: window.location.search, storage: window.localStorage }))
export function tutorialStore(uid) {
  if (!uid || tutorialAutomated()) return null
  if (storeUid !== uid) { store = createTutorialStore({ client: supabase, uid, storage: window.localStorage }); storeUid = uid; store.load() }
  return store
}
// a job done outside the card (a fleet tab, the fleet report button)
export function tutorialMark(key) { if (store) store.mark(key) }
